/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ApproveWorkflowStepPaymentRequestsRequestSupplier
 */
export interface ApproveWorkflowStepPaymentRequestsRequestSupplier {
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequestSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequestSupplier
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequestSupplier
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequestSupplier
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequestSupplier
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequestSupplier
     */
    'accountType': ApproveWorkflowStepPaymentRequestsRequestSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequestSupplier
     */
    'companyName': string;
}

export const ApproveWorkflowStepPaymentRequestsRequestSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type ApproveWorkflowStepPaymentRequestsRequestSupplierAccountTypeEnum = typeof ApproveWorkflowStepPaymentRequestsRequestSupplierAccountTypeEnum[keyof typeof ApproveWorkflowStepPaymentRequestsRequestSupplierAccountTypeEnum];


